module.exports = __webpack_public_path__ + "img/bg_ppt_cover.e744fd03.png";